<template>
    <div>
        <div v-for="month in collection" :class="{ 'col-sm-12 col-md-6 col-lg-6 col-xl-6': (toSwap != null || $parent.isQuickAdd) && collection[1].length, 'col-sm-12 col-md-12 col-lg-12 col-xl-12': (toSwap == null && !$parent.isQuickAdd) || !collection[1].length }" v-if="month.length > 0">
            <transition-group name="list">
                <div class="box-layout-inner" v-for="(item, key) in month" v-bind:key="key" :class="{ 'quick-form': toSwap != null || $parent.isQuickAdd}">
                    <div class="title-block" >
                        {{ item.month + ' ' + item.year }}
                    </div>

                    <div class="date-selection-blocks" v-for="(dates, week_id) in item.weeks" v-if="dates.state_id == 2">
                        <div class="date-inner"><!-- ON SALE -->
                            <div class="title-block" v-html="dates.title"></div>

                            <div class="date-block">
                                <div class="fields dropdown">
                                    <div class="dropdown-inner">
                                        <select v-model="selected[dates.package_id]">
                                            <option value="" disabled selected>Select days</option>
                                            <option value="">None</option>
                                            <option v-for="option in dates.options" v-html="option.text" :value="option.dates"></option>
                                            <option v-if="selected[dates.package_id] && dates.options.filter(e => e.dates == selected[dates.package_id]).length === 0" v-html="valToString(selected[dates.package_id])" :value="selected[dates.package_id]"></option>
                                            <option v-if="dates.full_week" disabled>-- To book 4 days, please switch to full-week booking --</option>
                                        </select>
                                        <i class="fa fa-chevron-down"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="date-selection-blocks" v-else-if="dates.state_id == 3">
                        <a class="date-inner full-width call-to-book" href="tel:0114 263 2160"><!-- CALL TO BOOK -->
                            <span><i class="fa fa-phone"></i> {{ $parent.locale.text_individual_days_call_to_book }} <span v-html="dates.title"></span></span>
                        </a>
                    </div>
                    <div class="date-selection-blocks" v-else-if="dates.state_id == 4">
                        <div class="date-inner full-width sold-out"><!-- SOLD OUT -->
                            <span><i class="fa fa-times"></i>The <span v-html="dates.title"></span> {{ $parent.locale.text_individual_days_sold_out }}</span>
                        </div>
                    </div>
                    <div class="date-selection-blocks" v-else-if="dates.state_id == 5">
                        <div class="date-inner full-width cancelled"><!-- CANCELLED -->
                            <span><i class="fa fa-times"></i>The <span v-html="dates.title"></span> {{ $parent.locale.text_individual_days_cancelled }}</span>
                        </div>
                    </div>
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        props: ['packages', 'selection', 'toSwap', 'current'],
        data () {
            return {
                months: [],
                collection: [],
                selected: []
            }
        },
        watch: {
            "selected": function () {
                this.selection.days_running = [];
                this.selection.packages = [];

                this.selected.forEach((dates, package_id) => {
                    if(dates != "") {
                        this.selection.packages[package_id] = package_id;
                        this.selection.days_running[package_id] = dates.split("|");
                    }
                })
            },
            'months': function () {
                var temp = [[], []];
                this.months.forEach((month, key) => {
                    var length = this.months.length;
                    if((length % 2 && key <= length/2) || (!(length % 2) && key < length/2))
                        temp[0].push(month);
                    else
                        temp[1].push(month);
                })
                this.collection = temp;
            }
        },
        methods: {
            valToString: function (val) {
                if(!val)
                    return '';
                let parts = val.split('|').map(dateString => {
                    let dateArray = dateString.split("-");
                    return new Date(dateArray[0], dateArray[1]-1, dateArray[2]).toDateString(true);
                });

                return parts.join(", ");
            }
        },
        computed: {
            available_dates: function () {
                var result = [];
                this.packages.forEach(packageObject => {
                    if(packageObject.package_state_id == 1)
                        return false; //Not listed

                    //Getting the start date of this package week in Date object
                    let startDateArray = packageObject.start_date.split("-");
                    let startDate = new Date(startDateArray[0], startDateArray[1]-1, startDateArray[2]);

                    //Getting the end date of this package week in Date object
                    let endDateArray = packageObject.end_date.split("-");
                    let endDate = new Date(endDateArray[0], endDateArray[1]-1, endDateArray[2]);

                    //Attaching this package to the result array which will contain each of the weeks by month
                    result[startDate.getMonth()] = result[startDate.getMonth()] || {year: startDate.getFullYear(), month: startDate.getStrMonth(), month_short: startDate.getStrMonth('short'), weeks: []};

                    let options = [], x, full_week = false;
                    //If all 5 dates are visible, allow (MON,TUE,WED|TUE,WED,THU|WED,THU,FRI|MON,TUE,WED,THU|TUE,WED,THU,FRI)
                    if(packageObject.days_running.length == 5) {
                        x = [
                            packageObject.days_running.slice(0, 3), //first 3 days
                            packageObject.days_running.slice(1, 4), //mid 3 days
                            packageObject.days_running.slice(2, 5), //last 3 day
                            packageObject.days_running.slice(0, 4),//first 4 days
                            packageObject.days_running.slice(1, 5),//last 4 days
                        ];
                    //If 4 dates are available, allow (MON,TUE,WED|WED,THU,FRI), point towards full week for (MON,TUE,WED,THU|TUE,WED,THU,FRI)
                    } else if(packageObject.days_running.length == 4) {
                        x = [
                            packageObject.days_running.slice(0, 3), //first 3 days
                            packageObject.days_running.slice(1, 4), //last 3 day
                        ];
                        full_week = true;
                    //If 3 dates are available, allow (MON,TUE,WED)
                    } else if(packageObject.days_running.length == 3) {
                        x = [
                            packageObject.days_running.slice(0, 3), //first 3 days
                        ];
                    } else {
                        return false;
                    }

                    if(x != undefined) {
                        x.forEach(array => {
                            let dates = array.map(dateString => {
                                let dateArray = dateString.split("-");
                                return new Date(dateArray[0], dateArray[1]-1, dateArray[2]);
                            });
                            options.push({
                                text: '(' + dates.length + ' days) ' + dates[0].formatRange(dates[dates.length-1]),
                                dates: array.join('|')
                            })
                        })
                    }

                    //Appending this packages week to the above month array
                    result[startDate.getMonth()].weeks[startDate.getWeek()] = {
                        title: startDate.formatRange(endDate),
                        options: options,
                        package_id: packageObject.id,
                        state_id: packageObject.package_state_id,
                        full_week: full_week
                    }
                    this.selected[packageObject.id] = '';
                })
                //Filtering out any months which don't have any weeks
                this.months = result.filter(function (item) {
                    return item.weeks.length > 0;
                });
                var dates_shown = false;
                this.months.forEach((item, key) => {
                    this.months[key].weeks = this.months[key].weeks.filter((item, dateKey) => {
                        return item != undefined;
                    })
                })
                this.months.forEach(month => {
                    month.weeks.filter(week => {
                        return week != undefined;
                    })
                })
            }
        },
        created () {
            this.available_dates;

            if(this.toSwap) {
                axios.get('/camp-booking/bookings/'+this.$root.getCookie('kingscamps_booking_id')+'/items/' + this.toSwap.id + '/similar')
                    .then(response => {
                        var packages = response.data.data;
                        packages.forEach(pack => {
                            //Only want to continue if the item is not cancelled
                            if(pack.booking_item_state_id != 4) {
                                Vue.set(this.selected, pack.package_id, pack.days_attending.join("|"))

                                this.selection.packages[pack.package_id] = pack.package_id;
                                this.selection.days_running[pack.package_id] = pack.days_attending.filter($date => {
                                    let dateArray = $date.split("-"), date = new Date(dateArray[0], dateArray[1]-1, dateArray[2]);
                                    return date.toShortDateString(true) >= (new Date()).toShortDateString(true);
                                });
                            }
                        });
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ShortWeeks.vue?1bd6611a